import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../material/material.module';
// import { FlexLayoutModule } from '@angular/flex-layout';

//components
import { TitleBackComponent } from './title-back/title-back.component';



@NgModule({
  declarations: [
    TitleBackComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    // FlexLayoutModule
  ],
  exports: [
    TitleBackComponent
  ]
})
export class ControlsModule { }
